import { SHOW_SNACK, CLEAR_ALL_STATE } from '../actions/types';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_SNACK:
      return action.payload;
    case CLEAR_ALL_STATE:
      return {};
    default:
      return state;
  }
};
